import React, { useState } from "react";
import "./feed-card.sass";
import { CheckboxSelect } from "../../../../../components/interface/inputs/checkbox-select/checkbox-select";
import { useDispatch, useSelector } from "react-redux";
import { updateSelectedPosts } from "../../../actions/posts.actions";
import { parseISO, formatDistanceToNow } from "date-fns";
import { GuardNames } from "../../../../../guards/guards-list";
import StatusButton, { POST_STATUS } from "../status-button/status-button";
import Author from "../../../../../components/author/author.jsx";
import FeedCardIcons from "../feed-card-icons/feed-card-icons";
import TintImagePreview from "../image-preview/image-preview";
import RightsStatusBar from "../rights-status-bar/rights-status-bar";
import HootsuiteBar from "../hootsuite-bar/hootsuite-bar";
import HUE from "../hue/hue";
import HUECircle from "../hue-circle/hue-circle";
import { Button } from "../../../../../components/interface/button/button";
import StarRating from "../star-rating/star-rating";
import TintIcon from "../../../../../components/interface/icon/icon";
import { faCartShopping, faTags } from "@fortawesome/free-solid-svg-icons";
import { faGrid2 } from "@fortawesome/pro-solid-svg-icons";
import { getPostCTAs } from "../../../reducers/tint-editor.reducer";
import CTA from "../cta/cta";
import Slider from "../../../../../components/interface/slider/slider";
import Tooltip from "../../../../transform-ui/components/tooltip/tooltip";
import { TintEditorConfig } from "../../../utils/tint-editor.config";
import { getTintName } from "../../../reducers/posts.reducer";
import usePercents from "../../../../../components/hooks/use-percents/use-percents";
import { openEcommerceModal } from "../../../actions/tint-editor.actions";
import FeatureGuard from "../../../../../guards/feature-guard";
const FeedCard = ({ post, tintId, onClickEcommerce, onPinFeed, onClick, maxIconCardLength }) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K;
  const dispatch = useDispatch();
  const CTAs = useSelector((state) => getPostCTAs(state, post.id));
  const tintEditorPosts = useSelector((state) => state.tintEditorPosts);
  const selectedPosts = tintEditorPosts == null ? void 0 : tintEditorPosts.selectedPosts;
  const productTagsCount = (_c = (_b = (_a = post == null ? void 0 : post.relationships) == null ? void 0 : _a.product_tags) == null ? void 0 : _b.data) == null ? void 0 : _c.length;
  const isChecked = selectedPosts.find((selectedPost) => selectedPost.id === post.id);
  const time = formatDistanceToNow(parseISO((_d = post == null ? void 0 : post.attributes) == null ? void 0 : _d.published_at), { addSuffix: true });
  const [isHUEVisible, setHUEVisibility] = useState();
  const select = () => {
    const updatedSelectPosts = isChecked ? selectedPosts.filter((selectedPost) => selectedPost.id !== post.id) : [...selectedPosts, post];
    dispatch(updateSelectedPosts(updatedSelectPosts));
  };
  const isGlobalPageState = tintId === TintEditorConfig.routePaths.global.tintId;
  const tintName = isGlobalPageState && useSelector((state) => {
    var _a2, _b2, _c2;
    return getTintName(state, (_c2 = (_b2 = (_a2 = post == null ? void 0 : post.relationships) == null ? void 0 : _a2.tint) == null ? void 0 : _b2.data) == null ? void 0 : _c2.id);
  });
  const huePercentValue = usePercents(1, (_e = post.attributes) == null ? void 0 : _e.hue_probability);
  const renderTags = () => {
    return post.attributes.tags.join(", ");
  };
  const hasTags = ((_f = post.attributes.tags) == null ? void 0 : _f.length) > 0;
  const currentDate = (/* @__PURE__ */ new Date()).getTime();
  const timestamp = new Date((_g = post == null ? void 0 : post.attributes) == null ? void 0 : _g.published_at).getTime();
  const hueTagList = (_i = (_h = post.attributes) == null ? void 0 : _h.image_objects) == null ? void 0 : _i.map((tag) => ({
    name: tag,
    value: tag
  }));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "tint-editor-feed-card" }, /* @__PURE__ */ React.createElement(FeatureGuard, { featureName: GuardNames.MODERATE_TINT }, /* @__PURE__ */ React.createElement("div", { className: "tint-editor-feed-card__moderate" }, /* @__PURE__ */ React.createElement(
    Tooltip,
    {
      style: { left: "-35px", bottom: "auto", top: "-36px", height: "30px", width: "110px", zIndex: "1" },
      component: /* @__PURE__ */ React.createElement(StatusButton, { status: (_j = post == null ? void 0 : post.attributes) == null ? void 0 : _j.status, postId: post.id }),
      text: ((_k = post == null ? void 0 : post.attributes) == null ? void 0 : _k.status) !== POST_STATUS.PUBLIC ? "Make visible" : "Make private"
    }
  ))), /* @__PURE__ */ React.createElement("div", { className: "tint-editor-feed-card__settings" }, /* @__PURE__ */ React.createElement(
    CheckboxSelect,
    {
      onClick: select,
      isChecked,
      checkboxId: post == null ? void 0 : post.id,
      style: { margin: "0 4px 0 0", width: "16px", height: "16px" }
    }
  ), /* @__PURE__ */ React.createElement(
    FeedCardIcons,
    {
      iconLength: maxIconCardLength,
      isGlobalPageState,
      isSelected: isChecked,
      tintId,
      post,
      onClickEcommerce,
      onPinFeed
    }
  )), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: `tint-editor-feed-card__photo ${isGlobalPageState ? "tint-editor-feed-card__photo--global-page" : ""}`,
      onClick: () => onClick(post)
    },
    ((_n = (_m = (_l = post == null ? void 0 : post.relationships) == null ? void 0 : _l.right_requests) == null ? void 0 : _m.meta) == null ? void 0 : _n.status) && /* @__PURE__ */ React.createElement(
      RightsStatusBar,
      {
        status: (_q = (_p = (_o = post == null ? void 0 : post.relationships) == null ? void 0 : _o.right_requests) == null ? void 0 : _p.meta) == null ? void 0 : _q.status,
        expireDate: (_t = (_s = (_r = post == null ? void 0 : post.relationships) == null ? void 0 : _r.right_requests) == null ? void 0 : _s.meta) == null ? void 0 : _t.status_expires_at,
        post,
        tintId
      }
    ),
    timestamp > currentDate && /* @__PURE__ */ React.createElement(HootsuiteBar, { date: timestamp }),
    /* @__PURE__ */ React.createElement(FeatureGuard, { featureName: GuardNames.HUE }, ((_u = post.attributes) == null ? void 0 : _u.hue_probability) && !isHUEVisible && /* @__PURE__ */ React.createElement(
      Button,
      {
        className: "hue-open",
        type: "no-style",
        onClick: (e) => {
          e.stopPropagation();
          setHUEVisibility(true);
        }
      },
      /* @__PURE__ */ React.createElement(HUECircle, { styles: { width: "12px", height: "12px" }, strokeWidth: 2 }),
      /* @__PURE__ */ React.createElement("span", null, huePercentValue, "%")
    ), isHUEVisible && ((_v = post.attributes) == null ? void 0 : _v.hue_probability) && /* @__PURE__ */ React.createElement(
      HUE,
      {
        tagList: hueTagList,
        probability: (_w = post.attributes) == null ? void 0 : _w.hue_probability,
        onClose: () => setHUEVisibility(false)
      }
    )),
    /* @__PURE__ */ React.createElement(TintImagePreview, { post })
  ), isGlobalPageState && /* @__PURE__ */ React.createElement("div", { className: "tint-editor-feed-card__bar tint-editor-feed-card__bar--tint-name" }, /* @__PURE__ */ React.createElement(TintIcon, { icon: faGrid2, fontSize: "16px" }), /* @__PURE__ */ React.createElement("span", null, tintName)), /* @__PURE__ */ React.createElement("div", { className: "tint-editor-feed-card__content" }, /* @__PURE__ */ React.createElement("div", { className: "tint-editor-feed-card__author" }, /* @__PURE__ */ React.createElement(
    Author,
    {
      author: {
        image_url: (_y = (_x = post == null ? void 0 : post.attributes) == null ? void 0 : _x.author) == null ? void 0 : _y.image_url,
        userName: (_A = (_z = post == null ? void 0 : post.attributes) == null ? void 0 : _z.author) == null ? void 0 : _A.username,
        name: (_C = (_B = post == null ? void 0 : post.attributes) == null ? void 0 : _B.author) == null ? void 0 : _C.name
      },
      authorUrl: (_D = post == null ? void 0 : post.attributes) == null ? void 0 : _D.author.url
    }
  )), ((_E = post.attributes) == null ? void 0 : _E.rating) ? /* @__PURE__ */ React.createElement("div", { className: "tint-editor-feed-card__description", onClick: () => onClick(post) }, /* @__PURE__ */ React.createElement(StarRating, { rating: post.attributes.rating }), ((_F = post.attributes) == null ? void 0 : _F.text) && /* @__PURE__ */ React.createElement("p", null, post.attributes.text)) : /* @__PURE__ */ React.createElement(React.Fragment, null, post.attributes.image_url && post.attributes.text && /* @__PURE__ */ React.createElement("div", { className: "tint-editor-feed-card__description", onClick: () => onClick(post) }, post.attributes.text)), /* @__PURE__ */ React.createElement("div", { className: "tint-editor-feed-card__time" }, ((_G = post == null ? void 0 : post.attributes) == null ? void 0 : _G.url) ? /* @__PURE__ */ React.createElement("a", { href: (_H = post == null ? void 0 : post.attributes) == null ? void 0 : _H.url, target: "_blank", rel: "noopener noreferrer" }, time) : /* @__PURE__ */ React.createElement("span", null, time))), (CTAs == null ? void 0 : CTAs.length) > 0 && /* @__PURE__ */ React.createElement("div", { className: "tint-editor-feed-card__cta" }, /* @__PURE__ */ React.createElement(Slider, null, CTAs.map((cta) => /* @__PURE__ */ React.createElement(CTA, { key: cta.id, cta }))))), /* @__PURE__ */ React.createElement("footer", { className: "tint-editor-feed-card__footer" }, ((_K = (_J = (_I = post == null ? void 0 : post.relationships) == null ? void 0 : _I.product_tags) == null ? void 0 : _J.data) == null ? void 0 : _K[0]) && /* @__PURE__ */ React.createElement("div", { className: "tint-editor-feed-card__bar" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(TintIcon, { icon: faCartShopping, fontSize: "16px" }), /* @__PURE__ */ React.createElement("span", null, `${productTagsCount} ${productTagsCount > 1 ? "Products" : "Product"} Tagged`)), /* @__PURE__ */ React.createElement(Button, { type: "no-style", onClick: () => dispatch(openEcommerceModal(post)) }, "Edit")), hasTags && /* @__PURE__ */ React.createElement("div", { className: "tint-editor-feed-card__bar" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(TintIcon, { icon: faTags, fontSize: "16px" }), /* @__PURE__ */ React.createElement("span", null, renderTags())))));
};
export default React.memo(FeedCard);
